import React from 'react';
import Icon_img from '../assets/images/icons/play-icon.png'; // Make sure to import your play icon image
import globeImage from '../assets/images/icons/globe.png';
import { Helmet } from "react-helmet-async";
import patternImage from '../assets/images/background/pattern-1.png';
import about_1 from '../assets/images/resource/about-company-office-male.jpg';
import about_2 from '../assets/images/resource/about-company-review-male.jpg';
import about_3 from '../assets/images/resource/about-company-collaboration-male.jpg';
import about_4 from '../assets/images/resource/about-4.jpg';
// import featureImage from '../assets/images/resource/feature-1.jpg';

const About = ({ }) => {
    const url = "https://www.swiftmazetech.com/services/about";
	  return (
		< >
{/* <section className="about-section">    yah class se About me top pe space rehti he*/}
<section className="about-section">
		<div className="auto-container">
			{/* <!-- Sec Title --> */}
			<div className="sec-title">
				<div className="title">ABOUT COMPANY</div>
				{/* <h2>You Can not Use Up <br/> Creativity.</h2> */}
				<h2>We Build Clear and Simple IT Work <br/> That Helps You Grow</h2>
			</div>
			<div className="row clearfix">
				
				{/* <!-- Content Column --> */}
				<div className="content-column col-lg-6 col-md-12 col-sm-12">
					<div className="inner-column">
						<div className="text">We work with brands and small teams in Modasa and nearby areas. Our aim is to make your web and software work easy. Our team keeps every step simple so you feel safe with us. We build websites, software, and marketing plans that support real work in your day-to-day life.</div>
						<div className="blocks-outer">
						  <h4 className="two-features-title mt-12 mb-6">Two Feature Points</h4>
						  {/* <h4 className="two-features-title" style={{ marginTop: "40px", marginBottom: "20px" }}>
						Two Feature Points
						</h4> */}

							{/* <!-- Feature Block --> */}
							<div className="feature-block">
								<div className="inner-box">
									<div className="icon flaticon-award-1"></div>
									<h6>Experience</h6>
									<div className="feature-text">From business websites to custom software, we have delivered practical projects for different industries. Our focus stays on dependable output that is simple for your team to run daily.</div>
								</div>
							</div>
							
							{/* <!-- Feature Block --> */}
							<div className="feature-block">
								<div className="inner-box">
									<div className="icon flaticon-technical-support"></div>
									<h6>Quick Support</h6>
									<div className="feature-text">You get fast help from our team when you need it. We keep our process open so you always know what is going on.</div>
								</div>
							</div>
							
						</div>
						{/* <a href="https://www.youtube.com/watch?v=kxPCFljwJws" className="lightbox-image theme-btn btn-style-one">
						<span className="txt">
							<i className="play-icon">
							<img src={Icon_img} alt="Play Icon" />
							</i>
							&ensp; intro Video
						</span>
						</a> */}
						{/* <a href="/contact" className="theme-btn btn-style-one"> */}
						<a href="/#project-contact" className="theme-btn btn-style-one">
						<span className="txt">Contact Us</span>
						</a>
					</div>
				</div>
				
				{/* <!-- Images Column --> */}
				<div className="images-column col-lg-6 col-md-12 col-sm-12">
				<div className="inner-column" style={{ backgroundImage: `url(${globeImage})` }}>
      			<div className="pattern-layer" style={{ backgroundImage: `url(${patternImage})` }}></div>
						<div className="images-outer parallax-scene-1">
							<div className="image" data-depth="0.10">
								<img src={about_1} alt="SwiftMaze team discussion in office workspace" />
							</div>
							<div className="image-two" data-depth="0.30">
								<img src={about_2} alt="SwiftMaze professionals collaborating on digital strategy" />
							</div>
							<div className="image-three" data-depth="0.20">
								<img src={about_3} alt="Team member presenting business growth ideas" />
							</div>
							<div className="image-four" data-depth="0.30">
								<img src={about_4} alt="Office collaboration meeting at SwiftMaze Technology" />
							</div>
						</div>
					</div>
					<a href="/about" className="learn"><span className="arrow flaticon-long-arrow-pointing-to-the-right"></span>Learn More About Company</a>
				</div>
			</div>
		</div>
	</section>
	
</>
  );
};

export default About;
